<script setup lang="ts">
import { defineEmits } from "vue";

type Emits = {
  (event: "onClose"): void;
};

const emits = defineEmits<Emits>();
</script>

<template>
  <div
    class="max-w-[854px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-h-[calc(100vh-48px)] overflow-y-hidden mx-auto flex flex-col items-start justify-between p-5 bg-white rounded-primary-radius"
  >
    <div class="w-full">
      <div class="w-full flex items-center justify-between mb-[13px]">
        <!-- Header -->
        <div>
          <slot name="header" />
        </div>
        <img
          @click="$emit('onClose')"
          src="@/assets/close-icon-2.svg"
          alt="Close icon"
          class="cursor-pointer"
        />
      </div>
      <!-- Progress bar -->
      <div class="mb-[24px]">
        <slot name="progress-bar" />
      </div>
      <!-- Content -->
      <div class="max-h-[700px] overflow-y-auto">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>
